import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@repo/ui/components/ui/dialog';
import type { Photo } from '@/services/photovogue';
import { getModerationFullUrl } from '@/services/photovogue/moderation-image';

export interface PhotoLightboxProps {
  photo: Photo | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const PhotoLightbox = ({
  photo,
  open,
  onOpenChange,
}: PhotoLightboxProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-[95vw] border-0 bg-black/95 p-2 sm:max-w-[90vw]">
      <DialogTitle className="sr-only">{photo?.title ?? 'Photo'}</DialogTitle>
      {photo && (
        <div className="flex h-[88vh] items-center justify-center">
          <img
            src={getModerationFullUrl(photo)}
            alt={photo.title}
            className="max-h-full max-w-full object-contain"
          />
        </div>
      )}
    </DialogContent>
  </Dialog>
);

export default PhotoLightbox;
